import React from "react";
import { Modal } from "react-bootstrap";
import Button from "components/CustomButton/CustomButton.jsx";

const NoMedicineAvailablePopup = ({ show, onHide }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#f0ad4e", color: "#fff" }}
      >
        <Modal.Title>
          <i className="pe-7s-attention" style={{ marginRight: "10px" }}></i>
          Warning
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ textAlign: "center", padding: "20px" }}>
          <p style={{ fontSize: "16px", color: "#8a6d3b" }}>
            No medication found for this batch number
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} fill bsStyle="warning">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NoMedicineAvailablePopup;
